import { useEffect } from 'react';

import { useAppointmentTypeSelector, useClinicSelector } from './useAsyncSelector';
import { isFaceToFace } from 'src/utils/appointmentTypes';
import { clinicName } from 'src/utils/name';

export function usePageTitle() {
    const { data: clinic } = useClinicSelector();
    const { data: appointmentType } = useAppointmentTypeSelector();

    useEffect(() => {
        if (clinic) {
            if (appointmentType && !isFaceToFace(appointmentType)) {
                // TODO set document title to something different for telehealth
                document.title = `${clinicName(clinic)!} - Book an Appointment`;
            } else {
                document.title = `${clinicName(clinic)!} - Book an Appointment`;
            }
        }
    }, [appointmentType, clinic]);
}
